export const PUBSUB_CMS_FRAMES_INITIALIZED = 'workspace-and-page-initialized';
export const PUBSUB_TAB_CHANGE_LAYOUT = 'sidebar-tab-opened-content';
export const PUBSUB_TAB_CHANGE_DESIGN = 'sidebar-tab-opened-theme';
export const PUBSUB_SAVE_REQUEST = 'page-save-request';
export const PUBSUB_SAVE_SUCCESS = 'page-saved';
export const PUBSUB_SAVE_ERROR = 'page-save-error';
export const PUBSUB_PAGE_CHANGES_MADE = 'page-changes-made';
export const PUBSUB_NAVIGATE_TO_EVENT_SETTINGS = 'navigate-to-event-settings';
export const PUBSUB_CONTEXT = 'splash-navigation';
